import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import ToolbarWrapper from 'components/templates/Wrappers/Toolbars/ToolbarWrapper/ToolbarWrapper';

const StyledDealflowEntityProfileBarWrapper = styled(ToolbarWrapper)`
  background-color: ${props => props.theme.property(`palette.primary.states.hover`)};
  
  ${ComponentStyles}
`;

StyledDealflowEntityProfileBarWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledDealflowEntityProfileBarWrapper;
